import { Component, inject, Input, OnInit } from '@angular/core';
import { VehicleSpecificationsPartViewModel } from "../../../../../models/VehicleSpecificationViewModel";
import { AccessRights, UsersService } from 'app/services/users.service';

@Component({
  selector: 'app-object-vechile-spec-part',
  templateUrl: './object-vechile-spec-part.component.html',
  styleUrls: ['./object-vechile-spec-part.component.css'],
  standalone: false
})
export class ObjectVechileSpecPartComponent implements OnInit {

  @Input()
  public model: VehicleSpecificationsPartViewModel;

  usersService = inject(UsersService);
  canEditTrackers: boolean = false;
  constructor() {
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }


  ngOnInit() {
  }

  checkEngVolume(event: Event) {
    const value = Number((event.currentTarget as HTMLInputElement).value);
    if (value > 0)
      this.model.EngineV = value;
    else
      this.model.EngineV = 0;
  }
  checkEngPower(event: Event) {
    const value = Number((event.currentTarget as HTMLInputElement).value);
    if (value > 0)
      this.model.EngineP = value;
    else
      this.model.EngineP = 0;
  }
}
